import React from 'react';
import { PageHero, SectionTitle, Input, Textarea } from '../components/PageUI';

const DemonstracaoPage = () => {
  return (
    <div>
      <PageHero
        eyebrow="Solicitar demonstração"
        title="Veja o Zartoo em ação."
        subtitle="Receba uma apresentação personalizada para sua operação."
        primaryCta={{ label: 'Falar com especialista', href: '/especialista' }}
      />

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16 max-w-3xl">
          <SectionTitle
            eyebrow="Formulário"
            title="Agende sua demo"
            description="Nossa equipe responde em até 1 dia útil."
          />
          <form className="grid md:grid-cols-2 gap-4">
            <Input label="Nome completo" placeholder="Digite seu nome" />
            <Input label="E-mail corporativo" type="email" placeholder="voce@empresa.com" />
            <Input label="Telefone/WhatsApp" placeholder="(11) 99999-9999" />
            <Input label="Empresa" placeholder="Nome da empresa" />
            <Input label="Cargo" placeholder="Seu cargo" />
            <Input label="Segmento" placeholder="Distribuidora, varejo..." />
            <Input label="Tamanho da empresa" placeholder="Número de usuários" />
            <Input label="Interesse" placeholder="ERP / APP / PDV / Todos" />
            <div className="md:col-span-2">
              <Textarea label="Mensagem (opcional)" rows={4} placeholder="Conte seu objetivo" />
            </div>
            <button type="submit" className="md:col-span-2 px-6 py-3 rounded-xl font-black text-lg bg-[#FF6B35] text-white">
              Solicitar demonstração
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default DemonstracaoPage;
